export type FeatureFlags = {
  register: boolean;
  registration_rate_limit: boolean;
  generate_ai_survey: boolean;
  generate_questionnaire_survey: boolean;
  create_team: boolean;
  design_tab_ai_toolbar: boolean;
  theme_tab_ai_toolbar: boolean;
  logic_tab_ai_toolbar: boolean;
  ai_suggestions: boolean;
  generate_theme_from_website: boolean;
  share_survey: boolean;
  export_survey: boolean;
  ai_assistant: boolean;
  ai_summary: boolean;
  [key: string]: boolean;
};

export type Environment = 'development' | 'production';

export type EdgeConfigFlags = FeatureFlags & {
  [K in Environment]: FeatureFlags;
};

export type EdgeConfigItems = EdgeConfigFlags;

export interface IEdgeConfigService {
  getItem(key: string): Promise<boolean | null>;
  getAllItems(): Promise<FeatureFlags>;
  updateItem(key: string, value: boolean): Promise<void>;
  deleteItem(key: string): Promise<void>;
}

export interface FlagCategory {
  name: string;
  description?: string;
  flags: string[];
}

export const FLAG_CATEGORIES: FlagCategory[] = [
  {
    name: 'Login / Registration',
    flags: ['register', 'registration_rate_limit'],
  },
  {
    name: 'Home Screen',
    flags: ['generate_ai_survey', 'generate_questionnaire_survey'],
  },
  {
    name: 'Teams',
    description: 'Only in Personal Workspace',
    flags: ['create_team'],
  },
  {
    name: 'Survey Builder - Design',
    flags: ['design_tab_ai_toolbar', 'ai_suggestions', 'matrix_question'],
  },
  {
    name: 'Survey Builder - Theme',
    flags: ['theme_tab_ai_toolbar', 'generate_theme_from_website'],
  },
  {
    name: 'Survey Builder - Logic',
    flags: ['logic_tab_ai_toolbar'],
  },
  {
    name: 'Survey Distribution',
    flags: ['share_survey'],
  },
  {
    name: 'Insight Hub',
    flags: ['export_survey', 'ai_assistant', 'ai_summary'],
  },
  {
    name: 'Automated Workflows',
    flags: ['workflows'],
  },
];
